import React from 'react';
import { motion } from 'framer-motion';
interface NavigationProps {
  onHomeClick?: () => void;
  onWorkClick?: () => void;
  onAboutClick?: () => void;
  currentView?: 'home' | 'about' | 'project';
}
export function Navigation({
  onHomeClick,
  onWorkClick,
  onAboutClick,
  currentView = 'home'
}: NavigationProps) {
  return <motion.header initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.19, 1, 0.22, 1]
  }} className="w-full px-6 md:px-12 pt-8 pb-4" data-id="element-36" data-mp="3sep5dti5jde2">
      <div className="max-w-7xl mx-auto" data-id="element-37" data-mp="5aio84dsfuw6">
        <div className="flex flex-col md:flex-row md:justify-between md:items-end mb-6 gap-4" data-id="element-38" data-mp="jzf58qxtoi8x">
          <div className={onHomeClick ? 'cursor-pointer group' : ''} onClick={onHomeClick} data-id="element-39" data-mp="f0vjorn558h3">
            <h1 className="text-xl font-bold tracking-tight text-ink group-hover:text-stone-medium transition-colors" data-id="element-40" data-mp="t0d2mqdr9rij">
              SHIHWEN WANG
            </h1>
            <p className="text-sm text-stone-medium mt-1" data-id="element-41" data-mp="p0mekufm5php">Product Designer</p>
          </div>
          <nav className="flex gap-8 items-end" data-id="element-42" data-mp="dha8pi65sd98">
            <button onClick={onWorkClick} className={`text-sm font-medium transition-colors ${currentView === 'home' || currentView === 'project' ? 'text-ink' : 'text-stone-medium hover:text-ink'}`} data-id="element-43" data-mp="hh145z6mrhk3">
              Work
            </button>
            <button onClick={onAboutClick} className={`text-sm font-medium transition-colors ${currentView === 'about' ? 'text-ink' : 'text-stone-medium hover:text-ink'}`} data-id="element-44" data-mp="rg9zowh5948k">
              About
            </button>
          </nav>
        </div>

        <div className="w-full h-[1px] bg-stone-border mb-6" data-id="element-45" data-mp="156vh0gqy964c" />
      </div>
    </motion.header>;
}